import { L3ServiceStatus, Preference } from '../../l3-services/model';
import { Address } from './Address.model';
import { GeocodingPrecision, MaintenanceStatus } from './enum';
import { GeographicCoordinates } from './GeographicCoordinates.model';

export interface L3ServiceLocationApiModel {
  itemId: number;
  orderNumber: number;
  preference: Preference;
  address: Address;
  serviceName?: string;
  coordinates?: GeographicCoordinates;
  geocodingPrecision: GeocodingPrecision;
  serviceStatus: L3ServiceStatus;
  maintenanceStatuses?: MaintenanceStatus[];
  notificationCount?: number;
}

export interface L3ServiceLocationViewModel {
  itemId: number;
  orderNumber: number;
  formattedAddress: string;
  serviceName?: string;
  preference: Preference;
  coordinates: GeographicCoordinates;
  geocodingPrecision: GeocodingPrecision;
  serviceStatus: L3ServiceStatus;
  maintenanceStatuses?: MaintenanceStatus[];
  notificationCount?: number;
}

export const mapL3ServiceLocationApiToViewModel = (locations: L3ServiceLocationApiModel[]): L3ServiceLocationViewModel[] => {
  return filterL3ServiceLocationsWithoutCoordinates(locations).map(location => ({
    itemId: location.itemId,
    orderNumber: location.orderNumber,
    preference: location.preference,
    formattedAddress: formatAddress(location.address),
    serviceName: location.serviceName,
    coordinates: location.coordinates,
    geocodingPrecision: location.geocodingPrecision,
    serviceStatus: location.serviceStatus,
    maintenanceStatuses: location.maintenanceStatuses,
    notificationCount: location.notificationCount,
  }));
};

type L3ServiceLocationWithCoordinatesApiModel =
  Omit<L3ServiceLocationApiModel, 'coordinates'>
  & Required<Pick<L3ServiceLocationApiModel, 'coordinates'>>;

export const filterL3ServiceLocationsWithoutCoordinates = (locations: L3ServiceLocationApiModel[]): (L3ServiceLocationWithCoordinatesApiModel)[] => {
  return locations.filter(location => Boolean(location.coordinates)) as L3ServiceLocationWithCoordinatesApiModel[];
};

export const formatAddress = (address: Address): string => {
  let formattedAddress = '';
  if (address.country) {
    formattedAddress += `${address.country}, `;
  }
  if (address.postalCode) {
    formattedAddress += `${address.postalCode} `;
  }
  if (address.city) {
    formattedAddress += `${address.city}, `;
  }
  if (address.street) {
    formattedAddress += `${address.street}`;
  }
  if (address.houseNumber) {
    formattedAddress += ` ${address.houseNumber}`;
  }
  if (formattedAddress.length) {
    return formattedAddress.endsWith(', ') ? formattedAddress.slice(0, -2) : formattedAddress;
  } else {
    return '---';
  }
};